<template>
	<div v-loading="loading">
		<div class="app-container">
			<div class="el-title">异常名录信息</div>
			<el-table v-loading="loading" border :data="nycmlxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50"/>
				<el-table-column label="列异时间" align="center" prop="lrrq">
					<template slot-scope="scope">
							{{ parseTime(scope.row.lrrq, '{y}年{m}月{d}日') }}
						</template>
				</el-table-column>
				<el-table-column label="列入类型" align="center" prop="lrlx">
				 	<template slot-scope="scope">
				 			{{ selectDictLabel(lrlxOptions,scope.row.lrlx) }}
				 		</template>
				 </el-table-column>
				 <el-table-column label="移出时间" align="center" prop="lrrq">
				 	<template slot-scope="scope">
				 			{{ parseTime(scope.row.ycrq, '{y}年{m}月{d}日') }}
				 		</template>
				 </el-table-column>
			     <el-table-column label="状态" align="center" prop="mlzt">
			 	<template slot-scope="scope">
					<el-tag :type="scope.row.mlzt==='1'?'warning':'success'" effect="dark">
			 			{{scope.row.mlzt==='1'?'列入':'移出'}}
					</el-tag>
			 		</template>
			     </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getYcmlxxList()" />
		 
		</div>
	</div>
</template>

<script>
	import {
		listYcmlxx
	} from "@/api/qygzs/yqyd";
 
	export default {
		name: 'Ycmlxx',		 
		props: {
			//企业内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				//异常名录信息列表
				nycmlxxList: [],			 
				 
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【异常名录信息列表】总条数
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
				//列入类型
				lrlxOptions: [],
				 
			}
		},
		created() {
			this.init();
			this.getDicts("fdw_LRLX").then(response => {
				this.lrlxOptions = response.data;
				// console.log(response.data)
			});
		},
		methods: {
			init() {
				this.loading = true;
				this.getYcmlxxList();
			},
			//获取年异常名录信息列表
			getYcmlxxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listYcmlxx(this.queryParams).then(response => {
					this.nycmlxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
